import achieve1 from "@/../../hypetrain/static/img/for-business/achieve1-1.png";
import achieve3 from "@/../../hypetrain/static/img/for-business/achieve1-3.png";
import achieve4 from "@/../../hypetrain/static/img/for-business/achieve1-4.png";
import jobSearch from "@/../../hypetrain/static/img/job-search.png";
import sparkles from "@/../../hypetrain/static/img/sparkles.png";
import { SITE_NAME } from "@/css/constants";
import { MarketingPageBenefits, MarketingPageConfig } from "@/types/marketing";

import { CTAMini } from "./CTAMini";

const options: MarketingPageConfig = {
  page: "JOB_SEARCH_COACHING",
  color: "#EA9924",
  metaTitle: `Online Job Search Coaching - ${SITE_NAME}`,
  metaDescription: `Meet your secret weapon for today’s hot job market. ${SITE_NAME}’s Job Search Coaching provides expert support for job searching, resume review, interview prep, negotiations and more.`,
  metaImage:
    "https://placement-pub.s3.us-east-2.amazonaws.com/job-search-meta.png",
  defaultHeadline: "Job Search Coaching",
  defaultSubHeader:
    "Meet 1:1 with a coach of your choice to land your dream job faster.",
  benefitsHeadline: "Get set up in no time",
  ctaText: "Transition faster with a coach",
  pricingIntro: "First session is only $29",
  audience: "D2C",
  serviceType: "session",
  specialtySlug: "job-search-coaching",
  FAQCategory: "Basics",
  marketingVideoId: 675941160,
  background: "linear-gradient(-25deg, #b279fa 18%, #6b74e6 76%)",
  brandBg: "rgb(39, 44, 106)",
  heroGraphic: jobSearch,
  heroGraphicWidth: "100%",
  playDark: false,
  useCases: [
    "room-to-grow",
    "change-roles",
    "find-career",
    "quit-boss",
    "whats-next",
    "interviews",
    "go-remote",
    "new-industry",
    "more-money",
    "resume",
    "use-education",
    "find-mission",
  ],
  pricingCTA: <CTAMini />,
  upsell: true,
};

const benefits: MarketingPageBenefits = {
  title: "Fly through your job search",
  subtitle: "Upgrade your strategy, resume, LinkedIn, and more",
  items: [
    {
      title: "Amplify Your Success",
      description: (
        <>
          Clients working with a {SITE_NAME} coach get more offers, faster than
          going alone.
        </>
      ),
      photo: achieve1,
      bgColor: "#FEF0ED",
    },
    {
      title: "Avoid Common Pitfalls",
      description: (
        <>
          Your coach will provide important feedback to help you leap over
          obstacles.
        </>
      ),
      photo: achieve4,
      bgColor: "#EBF3FD",
    },
    {
      title: "Develop Key Skills",
      description: (
        <>
          Nail your elevator pitch, practice common interview questions, and so
          much more!
        </>
      ),
      photo: sparkles,
      bgColor: "#FDF7E9",
    },
    {
      title: "Grow Your Career",
      description: (
        <>
          With your coach you will find more than a job. You will chart a course
          for growing a fulfilling career.
        </>
      ),
      photo: achieve3,
      bgColor: "#E9F7EF",
    },
  ],
};

export default {
  options,
  benefits,
};
